module.exports = __webpack_public_path__ + "static/winter_wolf-f6c2290647c0a6b84c62e9eb3269326a.jpeg";